import React, {lazy, Suspense, useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
const IntegrationTypeCard = lazy(() => import('../../components/AlertAnalytics/IntegrationTypeCard'));
const ApplicationServiceCard = lazy(() => import('../../components/AlertAnalytics/ApplicationServiceCard'));
const MostFrequentAlertsCard = lazy(() => import('../../components/AlertAnalytics/MostFrequentAlertsCard'));
const AlertOpenAndCloseWithin5MinutesCard = lazy(() => import('../../components/AlertAnalytics/AlertOpenAndCloseWithin5MinutesCard'))
import AlertAnalyticsActions from "components/AlertAnalytics/AlertAnalyticsActions";
import { Row, Col } from "reactstrap";


const AlertAnalytics = (props) => {
    const [selectedTeamIds, setSelectedTeamIds] = useState([]);
    return (
        <React.Fragment>
            <Col lg={12} style={{ marginBottom: '20px' }}>
                <AlertAnalyticsActions setSelectedTeamIds={setSelectedTeamIds} />
            </Col>
            <Suspense fallback={
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '2rem',
                    color: '#0d6efd',
                }}>
                    <div className="spinner-border text-primary" role="status"></div>
                </div>
            }>
            <Row>
                <Col lg={6}>
                    <IntegrationTypeCard
                        title="Alerts based on Integration Type"
                    />
                </Col>
                <Col lg={6}>
                    <ApplicationServiceCard
                        title="Alerts based on Application Service"
                    />
                </Col>
                <Col lg={12}>
                    <MostFrequentAlertsCard
                        title="Most Frequent Alerts"
                    />
                </Col>
                <Col lg={12}>
                    <AlertOpenAndCloseWithin5MinutesCard
                        title="Alerts Opened and Closed within 5 Minutes"
                        selectedTeamIds={selectedTeamIds}
                    />
                </Col>
            </Row>
            </Suspense>
        </React.Fragment>
    );
};

AlertAnalytics.propTypes = {
    props: PropTypes.array,
};

export default withRouter(AlertAnalytics);
